import convertNumberToFinancialString from '../utility/convertNumberToFinancialString';

class CrmLineItem {
  constructor(productNumber, description, quantity, discount, listPrice, currency) {
    this.productNumber = productNumber;
    this.description = description;
    this.quantity = quantity;
    this.discount = discount;
    this.listPrice = listPrice;
    this.currency = currency;
  }

  get totalPrice() {
    const { total } = this;
    return total < 0
      ? convertNumberToFinancialString(0, this.currency)
      : convertNumberToFinancialString(total, this.currency);
  }

  get total() {
    const baseTotal = this.quantity * this.listPrice;
    if (!this.discount) {
      return baseTotal;
    }
    let total;
    let discountString = this.discount;
    if (typeof discountString !== 'string') {
      discountString = String(discountString);
    }
    if (discountString.includes('%')) {
      total = baseTotal - (baseTotal * (discountString.split('%')[0] / 100));
    } else {
      discountString = discountString.replace('$', '');
      total = baseTotal - parseFloat(discountString);
    }
    return total;
  }

  get discountDisplay() {
    if (!this.discount || this.discount === '0') {
      return '';
    }
    let discountDisplay = this.discount;
    if (typeof discountDisplay !== 'string') {
      discountDisplay = String(discountDisplay);
    }
    return discountDisplay.includes('%')
      ? this.discount
      : convertNumberToFinancialString(discountDisplay.replace('$', ''), this.currency);
  }

  get listPriceDisplay() {
    return this.listPrice || this.listPrice !== '0'
      ? convertNumberToFinancialString(this.listPrice, this.currency)
      : convertNumberToFinancialString(0, this.currency);
  }
}

export default CrmLineItem;
